import { Spinner } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface GMetrixLoaderProps {
    className?: string;
    loadingText?: string;
    role?: 'status' | undefined;
    size?: 'sm' | undefined;
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light' | undefined;
}

export const GMetrixLoader = (props: GMetrixLoaderProps) => {

    const { formatMessage } = useIntl();
    const { className, loadingText = formatMessage({ id: 'loading.2350c7f9', defaultMessage: 'Loading...' }), role = 'status', size = undefined, variant = 'primary' } = props;

    return (
        <Spinner animation='border' as='span' className={className} role={role} size={size} variant={variant}>
            <span className='visually-hidden'>
                {loadingText}
            </span>
        </Spinner>
    );

};
